import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { DollarSign } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function BeautySalonsRevenuePage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Relatório de Receitas"
      description="Análise financeira das receitas do salão."
      icon={DollarSign}
    />
  
    </MainLayout>);
}

